<template>
  <div class="">
    <div class="sidebar-cnt">
      <CategoryList :categories="categories" :type="this.type"></CategoryList>
    </div>
    <div class="content">
      <div class="header">
        <div class="meta">
          <div class="breadcrumbs">
            <div class="cat1">{{ breadcrumbs.cat1 }}</div>
            <div v-if="breadcrumbs.cat2" class="cat2">
              {{ breadcrumbs.cat2 }}
            </div>
          </div>
          <h1 v-if="breadcrumbs.name" class="title">{{ breadcrumbs.name }}</h1>
        </div>
        <div class="filter">
          <!--           <Searcher string="" :refresh="true"></Searcher> -->
          <LangSelector v-if="!file && market === 'ES'" :unique="!onlyCast"></LangSelector>
        </div>
      </div>
      <FileList :type="this.type" @uniqueLang="uniqueLang"></FileList>
    </div>
  </div>
</template>

<script>
import CategoryList from "@/components/domain/files/CategoryList";
import FileList from "@/components/domain/files/FileList";
import LangSelector from "@/components/ui/LangSelector";

export default {
  name: "Category",
  props: { type: Number },
  components: { CategoryList, FileList, LangSelector },
  data() {
    return {
      id: "ID1",
      onlyCast: true
    };
  },
  computed: {
    categories() {
      console.log("categories() + " + this.type);
      return this.$store.getters["files/getCategories"](this.type);
    },

    breadcrumbs() {
      var current = { name: "", cat1: "", cat2: "" };
      console.log(this.$store.getters["files/getCategories"](this.type));
      for (var i in this.$store.getters["files/getCategories"](this.type)) {
        var cat1 = this.categories[i];
        if (cat1.selected) {
          // this.$router.push( { name: 'nacional_category', params: { category: cat2.childs[k].url } } );
          current = {
            name: cat1.name,
            cat2: false,
            cat1: cat1.name
          };
        }
        for (var j in cat1.childs) {
          var cat2 = cat1.childs[j];
          for (var k in cat2.childs) {
            if (cat2.childs[k].selected) {
              // this.$router.push( { name: 'nacional_category', params: { category: cat2.childs[k].url } } );
              current = {
                name: cat2.childs[k].name,
                cat2: cat2.name,
                cat1: cat1.name
              };
              return current;
            }
          }
          if (cat2.selected) {
            // this.$router.push( { name: 'nacional_category', params: { category: cat2.childs[k].url } } );
            current = {
              name: cat2.name,
              cat2: false,
              cat1: cat1.name
            };
          }
        }
      }

      return current;
    },

    file() {
      return this.$store.getters["files/getCurrentFile"];
    },

    market() {
      return this.$store.getters["getMarket"];
    }
  },
  methods: {
    loadDataPage() {
      this.$overlay.loading();
      this.$store.commit("setMenuVisible", false);
      var self = this;

      this.$store.commit("files/setFiles", false);

      this.$store
        .dispatch("files/loadCategories", { type: this.type })
        .then(function() {
          if (
            typeof self.$route.params.category !== "undefined" &&
            self.$store.getters["files/getCategoryByURL"](
              self.type,
              self.$route.params.category
            )
          ) {
            self.$store.commit("files/selectCategory", {
              type: self.type,
              category: {
                id: self.$store.getters["files/getCategoryByURL"](
                  self.type,
                  self.$route.params.category
                )
              }
            });
          } else {
            self.$store.commit("files/setCurrentFile", false);
            if (self.type == 1) {
              self.$router.replace({ name: "category" });
            } else if (self.type == 2) {
              self.$router.replace({ name: "local" });
            } else if (self.type == 3) {
              self.$router.replace({ name: "comunicacion" });
            }
          }

          if (
            typeof self.$store.getters["files/getCurrentCategory"].id !==
            "undefined"
          ) {
            self.$store
              .dispatch("files/loadFiles", {
                id: self.$store.getters["files/getCurrentCategory"].id,
                overwride: false
              })
              .then(function() {
                if (typeof self.$route.params.resource !== "undefined") {
                  var resource = self.$store.getters["files/getResourceByURL"](
                    self.$route.params.resource
                  );
                  if (resource) {
                    self.$store.commit("files/setCurrentFile", resource);
                  } else {
                    var path = "";
                    if (self.type == 1) {
                      path = "nacional_category";
                    } else if (self.type == 2) {
                      path = "local_category";
                    } else if (self.type == 3) {
                      path = "comunicacion_category";
                    }
                    console.log(
                      self.$store.getters["files/getCurrentCategory"]
                    );
                    self.$router.replace({
                      name: path,
                      params: {
                        category:
                          self.$store.getters["files/getCurrentCategory"].url
                      }
                    });
                  }
                }
                self.$overlay.hide();
              });
          }
        });

      var title = this.$t('general.header_types.national');
      if (this.type == 2) {
        title = this.$t('general.section_types.local');
      } else if (this.type == 3) {
        title = this.$t('general.section_types.support');
      }
      this.$store.commit("setTitle", title);
    },

    uniqueLang(isUnique) {
      if (this.market === 'ES') {
        if (isUnique) {
          this.onlyCast = false;
        } else {
          this.onlyCast = true;
          this.$store.commit("setLanguage", "CAST");
        }
      } else if (this.market === 'PT') {
        this.onlyCast = false;
        this.$store.commit("setLanguage", "PT");
      }
    }
  },
  watch: {
    // call again the method if the route changes
    $route: "loadDataPage"
  },
  created() {
    this.loadDataPage();
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("files/setCurrentFile", false);
    next();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.sidebar-cnt {
  width: 300px;
  display: inline-block;
  float: left;
}
.content {
  width: calc(100% - 300px);
  display: inline-block;
  float: left;
  padding: 20px 40px;
  margin-left: 350px;

  .header {
    width: 100%;
    text-align: left;
    margin-bottom: 15px;
    overflow: hidden;

    .meta {
      float: left;
      width: 70%;

      .breadcrumbs {
        color: #aaa;
        display: block;
        width: 100%;

        .cat1 {
          display: inline-block;
          font-weight: bold;
          font-family: Speedee-Bold;
        }
        .cat2 {
          display: inline-block;

          &:before {
            content: "|";
            margin: 0 5px;
          }
        }
      }
      .title {
        background: var(--main_color);
        color: var(--dark_color);
        width: auto;
        display: inline-block;
        text-align: left;
        float: left;
        font-size: 25pt;
        font-family: Speedee-Bold;
        padding: 0 5px;
        margin: 0;
        margin-top: 5px;
        line-height: 25pt;
        padding-bottom: 5px;
      }
    }

    .filter {
      float: left;
      width: 30%;
      text-align: right;
      padding: 0 10px;

      .search {
        display: block;
        overflow: hidden;
        margin-top: 5px;
        -webkit-transition: all 1s;
        transition: all 1s;

        .input {
          border: none;
          border-bottom: 2px solid #ccc;
          padding: 5px;
          outline: none;
          background: url("/img/magnify.svg") no-repeat right 5px center;
          background-size: 20px;
          width: 100%;
          float: left;
        }
        .icon {
          display: none;
          cursor: pointer;
          width: 30px;
          height: 30px;
          background: url("/img/go.svg") no-repeat center var(--main_color);
          background-size: 20px;
          border-radius: 3px;
        }
        &.active {
          .input {
            width: calc(100% - 40px);
            background: transparent;
          }
          .icon {
            display: inline-block;
          }
        }
      }
    }
  }
}
</style>
